import {ecSendData, trackEvent} from "../../library/analytics";
import {popupInfoDialog} from "../../library/info-dialog";
import {addToCartAjax} from "./add-to-cart-personalized";
import {showShoppingCart} from "./product-shopping-cart";
import {uploadImage} from "./upload-image";
import {getPriceFormat} from "./price-format";
import {configureHelpWidget} from "./help-widget";

var minimumPriceLabel = '';

function getPlaceholder(type) {
    return $('#motorbikeOptions').data(type + '-placeholder') || '';
}

function showMinimumPrice() {
    if (minimumPriceLabel !== '') {
        $('.btn-item-price').text(minimumPriceLabel);
    }
}

$(document).ready(function() {
    $('#uploadedDesignPath').val('');
    minimumPriceLabel = $('.btn-item-price').first().text();
    configureHelpWidget();

    $('#motorbikeBrand').on('change', function() {
        resetYear();
        resetModel();
        if (!this.value) {
            return;
        }

        loadModels(this.value);
    });

    $('#motorbikeModel').on('change', function() {
        resetYear();
        var option = $(this).find(':selected');
        $('#motorbikeModelType').val(option.attr('data-type') || '');
        if (!this.value) {
            return;
        }

        loadYears(this.value);
    });

    $('#motorbikeYear').on('change', function() {
        var option = $(this).find(':selected');
        $('#motorbikeYearId').val(option.val() || '');
        $('#deviceId').val(option.attr('data-device') || '');
        $('#width').val(option.attr('data-width') || '');
        $('#height').val(option.attr('data-height') || '');
        if (option.attr('data-model-type')) {
            $('#motorbikeModelType').val(option.attr('data-model-type'));
        }

        if (option.val()) {
            updatePrice();
        } else {
            showMinimumPrice();
        }
    });

    $('#upload-file').on('change', function(event) {
        uploadImage(
            event.target.files,
            {prefix: 'personalized'},
            function(data) {
                $('#uploadedDesignPath').val(data.fileInfo.file);
                if (data.fileInfo.printable) {
                    $('#uploaded-image').attr('src', '/' + data.fileInfo.file);
                    $('.upload-block').fadeOut('fast', function() {
                        $('.preview-block').fadeIn('fast');
                    });
                } else {
                    $('#no-preview-name').text(data.fileInfo.originalName);
                    $('.upload-block').fadeOut('fast', function() {
                        $('.no-preview-block').fadeIn('fast');
                    });
                }
                $('#btnReplaceDesign').fadeIn('fast');
                trackEvent('MotorbikeKitPersonalized', 'Upload', 'ok');
            },
            function(data) {
                replaceDesign();
                popupInfoDialog(data.error);
            }
        );
    });

    $('#btnReplaceDesign').on('click', replaceDesign);
    $(document).on('change', '.qty-display, input[name="quantity"]', updatePrice);
    $(document).on('click', '.quantity-selector li', function () {
        var container = $(this).closest('.quantity-selector');
        var preview = container.find('.quantity-preview');
        var input = $(this).find('input[name="quantity"]');
        var quantity = parseInt(input.val(), 10) || 1;

        container.find('li').removeClass('selected');
        $(this).addClass('selected');
        input.prop('checked', true).trigger('change');
        preview.text(quantity);
    });
    $(document).on('click', '.btn-add-to-cart', addToCart);
});

function loadModels(brandId) {
    $('#motorbikeModel').prop('disabled', true).html('<option>...</option>');
    $.post('/ajax/service/motorbike-kit/load-models', {brandId: brandId}, function(models) {
        var options = '<option value="">' + escapeHtml(getPlaceholder('model')) + '</option>';
        $.each(models, function(index, model) {
            options += '<option value="' + model.id + '" data-type="' + escapeHtml(model.type || '') + '">' +
                escapeHtml(model.name) + '</option>';
        });
        $('#motorbikeModel').html(options).prop('disabled', false);
        if (models.length === 1) {
            $('#motorbikeModel').val(String(models[0].id)).trigger('change');
        }
    }, 'json');
}

function loadYears(modelId) {
    $('#motorbikeYear').prop('disabled', true).html('<option>...</option>');
    $.post('/ajax/service/motorbike-kit/load-years', {modelId: modelId}, function(years) {
        var options = '<option value="">' + escapeHtml(getPlaceholder('year')) + '</option>';
        $.each(years, function(index, year) {
            if (year.modelType) {
                $('#motorbikeModelType').val(year.modelType);
            }
            var width = normalizeNullableValue(year.width);
            var height = normalizeNullableValue(year.height);
            options += '<option value="' + year.id + '" data-device="' + year.deviceId +
                '" data-width="' + width + '" data-height="' + height +
                '" data-model-type="' + escapeHtml(year.modelType || '') + '">' +
                escapeHtml(year.year) + '</option>';
        });
        $('#motorbikeYear').html(options).prop('disabled', false);
        if (years.length === 1) {
            $('#motorbikeYear').val(String(years[0].id)).trigger('change');
        }
    }, 'json');
}

function resetModel() {
    $('#motorbikeModel').html('<option value="">' + escapeHtml(getPlaceholder('model')) + '</option>').prop('disabled', true);
    $('#motorbikeModelType').val('');
}

function resetYear() {
    $('#motorbikeYear').html('<option value="">' + escapeHtml(getPlaceholder('year')) + '</option>').prop('disabled', true);
    $('#motorbikeYearId, #deviceId, #width, #height').val('');
    showMinimumPrice();
}

function updatePrice() {
    var width = normalizeNullableValue($('#width').val());
    var height = normalizeNullableValue($('#height').val());
    var device = normalizeNullableValue($('#deviceId').val());
    var modelType = $('#motorbikeModelType').val();
    if (!device || !modelType) {
        showMinimumPrice();
        return;
    }

    var quantity = parseInt($('input[name="quantity"]:checked').val(), 10) || 1;
    $('.btn-add-to-cart').attr('disabled', 'disabled');
    var payload = {
        productId: $('#productId').val(),
        device: device,
        quantity: quantity,
        options: {
            motorbikeModelType: modelType
        },
        isCatalogSize: 1
    };
    if (width && height) {
        payload.width = width;
        payload.height = height;
    }

    $.post('/ajax/product/calculate-custom-price', payload, function(data) {
        if (data.error) {
            popupInfoDialog(data.error);
            showMinimumPrice();
            $('.btn-add-to-cart').removeAttr('disabled');
            return;
        }
        var total = data.price * quantity;
        $('.btn-item-price').text(getPriceFormat(total));
        $('.btn-add-to-cart').removeAttr('disabled');
    }, 'json').fail(function(xhr) {
        var message = 'Error';
        if (xhr.responseJSON && xhr.responseJSON.error) {
            message = xhr.responseJSON.error;
        }
        popupInfoDialog(message);
        showMinimumPrice();
        $('.btn-add-to-cart').removeAttr('disabled');
    });
}

function addToCart() {
    // Make sure hidden inputs match the currently selected options.
    // This prevents cart validation errors if the dropdown changed but the cached values were not updated.
    var selectedYearOption = $('#motorbikeYear').find(':selected');
    if (selectedYearOption && selectedYearOption.val()) {
        $('#motorbikeYearId').val(selectedYearOption.val() || '');
        $('#deviceId').val(normalizeNullableValue(selectedYearOption.attr('data-device')));
        $('#width').val(normalizeNullableValue(selectedYearOption.attr('data-width')));
        $('#height').val(normalizeNullableValue(selectedYearOption.attr('data-height')));
        if (selectedYearOption.attr('data-model-type')) {
            $('#motorbikeModelType').val(selectedYearOption.attr('data-model-type'));
        }
    }

    var selectedModelOption = $('#motorbikeModel').find(':selected');
    if (selectedModelOption && selectedModelOption.val() && selectedModelOption.attr('data-type')) {
        $('#motorbikeModelType').val(selectedModelOption.attr('data-type'));
    }

    var file = $('#uploadedDesignPath').val();
    var year = $('#motorbikeYearId').val();
    var modelType = $('#motorbikeModelType').val();

    var quantity = parseInt($('input[name="quantity"]:checked').val(), 10) || 1;
    var brandId = $('#motorbikeBrand').val();
    var modelId = $('#motorbikeModel').val();
    var motorcycleName = $.trim($('#motorbikeBrand option:selected').text() + ' ' +
        $('#motorbikeModel option:selected').text() + ' ' +
        $('#motorbikeYear option:selected').text());

    var width = normalizeNullableValue($('#width').val());
    var height = normalizeNullableValue($('#height').val());
    var device = normalizeNullableValue($('#deviceId').val());
    var cartOptions = {
        device: device,
        motorbikeBrand: brandId,
        motorbikeModel: modelId,
        motorbikeYear: year,
        motorbikeModelType: modelType,
        personalizedImage: file,
        personalizedImageText: motorcycleName,
        personalizedImageFromWeb: false
    };
    if (width && height) {
        cartOptions.width = width;
        cartOptions.height = height;
    }

    var complements = [];
    $('input[name="complement"]:checked').each(function() {
        var complement = $(this);
        complements.push({
            id: complement.data('id'),
            locked: complement.data('locked'),
            linkToParent: complement.data('link-to-parent'),
            options: {
                width: complement.data('width'),
                height: complement.data('height'),
                device: complement.data('device'),
                composition: complement.data('composition')
            }
        });
    });

    addToCartAjax({
        productId: $('#productId').val(),
        quantity: quantity,
        options: cartOptions,
        complements: complements,
        convertUM: false,
        isLocked: true
    }, successAddToCart, failureAddToCart);
}

function successAddToCart(data) {
    if (data.cartItems) {
        $.each(data.cartItems, function(index, item) {
            if (item) {
                ecSendData(item.reference || '', item.name, item.price, item.quantity, item.colorApaCode, item.size, 'normal', 'add', null);
            }
        });
    }
    trackEvent('MotorbikeKitPersonalized', 'AddToCart', $('h1').text());
    $('input[name="complement"]:checked').prop('checked', false);
    $('#complement-491').prop('checked', true);
    replaceDesign();
    showShoppingCart();
}

function failureAddToCart(data) {
    popupInfoDialog(typeof data.errorMessage === 'string' ? data.errorMessage : 'Error');
}

function replaceDesign() {
    $('#upload-file').val('');
    $('#uploadedDesignPath').val('');
    $('.preview-block, .no-preview-block').hide();
    $('.upload-block').fadeIn('fast');
    $('#btnReplaceDesign').hide();
}

function escapeHtml(value) {
    return $('<div>').text(value).html();
}

function normalizeNullableValue(value) {
    if (value === undefined || value === null) {
        return '';
    }
    var normalized = $.trim(String(value));
    if (normalized === '' || normalized.toLowerCase() === 'null' || normalized.toLowerCase() === 'undefined') {
        return '';
    }

    return normalized;
}
